import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    card: {
      position: "relative",
      zIndex: 0,
      height: "auto",
      aspectRatio: (props) => props.aspectRatio,
      backgroundColor: theme.palette.placeholder,
      "&:hover $cardOverlay": {
        visibility: "visible",
      },
      "&:active $cardOverlay": {
        visibility: "visible",
      },
      "& .lazyload-wrapper": {
        display: "inline",
      },
    },
    cardOverlay: {
      position: "absolute",
      zIndex: 2,
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(37, 45, 95, 0.7)",
      visibility: "hidden",
      display: "flex",
      transform: "visibility 0.1s ease-in",
      flexDirection: "column",
    },
    cardImg: {
      display: "block",
      maxWidth: "100%",
      maxHeight: "100%",
      position: "relative",
      left: 0,
      top: 0,
      zIndex: 1,
    },
    nameOverlay: {
      position: "absolute",
      zIndex: 2,
      left: 0,
      bottom: 0,
      height: "auto",
      width: "100%",
      backgroundColor: "rgba(18, 36, 56, 0.7)",
      display: "flex",
      justifyContent: "center",
      flexDirection: "column",
    },
    nameOverlayMasonry: {
      height: 20,
      [theme.breakpoints.up("tablet")]: {
        height: 30,
      },
    },
    name: {
      color: theme.palette.common.white,
      opacity: 0.7,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      padding: [5, 10],
      [theme.breakpoints.up("mobile")]: {
        padding: [0, 10],
        fontSize: theme.typography.small.fontSize,
      },
      [theme.breakpoints.up("tablet")]: {
        fontSize: theme.typography.large.fontSize,
      },
    },
    nameMasonry: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      padding: 0,
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      [theme.breakpoints.up("tablet")]: {
        fontSize: theme.typography.regular.fontSize,
      },
    },
  }),
  { name: "StraightUp" },
);
